import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogTitle, Modal, Box, TextField, Checkbox  } from '@mui/material'
import Pagination from "react-js-pagination";
import { RiShoppingCartLine } from 'react-icons/ri';
import { MdLockOutline } from 'react-icons/md';
import { BiTimeFive } from 'react-icons/bi';
import mainPath from '../../../utils/path';


const useStyles = makeStyles((theme)=>({
  ShopItemBlock:{
    padding:'270px 0 0 0',

    fontFamily:[
      'Noto Sans KR'
    ],
    [theme.breakpoints.down(1025)]: {
      padding:'132px 0 0 0',
    },
  },
  row:{
    maxWidth:'1200px', 
    margin:'0 auto', 
    padding:'10px', 
  },
  rightLeftFlexDiv:{
    display:'flex',
    justifyContent:'space-evenly',
    paddingTop:'3%',

    [theme.breakpoints.down(1025)]: {
      flexDirection: 'column',
    }
  },
  LeftDiv:{
    width:'60%',

    [theme.breakpoints.down(1025)]: {
        width:'100%',
        padding:'0 20px',
    }
  },
  rightDiv:{
    width:'40%',
    [theme.breakpoints.down(1025)]: {
        width:'100%',
        padding:'20px 20px 0 20px',
    }
  },
  arrowRightDiv:{
    display:'flex',
    justifyContent:'center'
  },
  arrowRight:{
    fontSize:'20px',
    color:'#007235',
  },
  arrowLeftDiv:{
    display:'flex',
    justifyContent:'center',
  },
  arrowLeft:{
    fontSize:'20px',
    color:'#007235',
  },
  imgDiv:{
    display:'flex',
    height:'450px',
    [theme.breakpoints.down(1025)]: {
      justifyContent:'center',
      flexDirection: 'column-reverse',
      height:'100%',
    }
  },
  smallImgDiv:{
    width: 150,
    height: 450,
    overflowY: 'scroll',
    overflowScrolling: "touch",
    WebkitOverflowScrolling: "touch",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'gray',
      borderRadius: 30
    },
    [theme.breakpoints.down(1025)]: {
      display: 'none'
    }
  },
  smallImgDivM: {
    display: 'none',
    [theme.breakpoints.down(1025)]: {
      display: 'block',
      width: '100%',
      height: 120,
      overflow: 'auto',
      whiteSpace: 'nowrap',
      overflowScrolling: "touch",
      WebkitOverflowScrolling: "touch",
      '&::-webkit-scrollbar': {
        width: '0.3em',
        height: 5,
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 3px rgba(0,0,0,0.00)'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#dcdcdc',
        borderRadius: 30,
      },
    }
  },
  smallImg:{
    width: 140,
    height: 140,
    backgroundSize: '140px 140px',
    marginBottom:'10px',
    [theme.breakpoints.down(1025)]: {
      width: '100px',
      height: '100px',
      margin:'5px',
      backgroundSize: '100px 100px',
      '&:nth-child(6)':{ 
        marginRight:'0'
      },

    }
  },
  smallImgM:{
    width: 100,
    height: 100,
    margin:'5px',
    backgroundSize: '100px 100px',
    display: 'inline-block'
  },
  mainImgDiv:{
    padding:'0 10px',
    [theme.breakpoints.down(1025)]: {
      textAlign:'center',
      paddingBottom:'10px',
      padding:'0'
    }
  },
  mainimg:{
    width:'450px', 
    height:'450px',
    [theme.breakpoints.down(535)]: {
      width:'300px',
      height:'300px',
    },
    [theme.breakpoints.down(316)]: {
      width:'200px',
      height:'200px',
    }
  },
  h1Div:{
    borderBottom:'1px solid #555'
  },
  rightDivH1:{
    fontSize:'25px',
    letterSpacing:'-1.5px',
  },
  itemDetailDiv:{
    display:'flex',
    flexDirection:'column',
    borderBottom:'1px solid #555'
  },
  itemDetailSpanDiv:{
    padding:'10px 0',
  },
  itemDetailSpanFirstDiv:{
    padding:'20px 0 10px 0'
  },
  itemDetailSpanLastDiv:{
    padding:'10px 0 20px 0'
  },
  itemDetailSpan:{
    display:'inline-block',
    width:'100px',
  },
  cartDiv:{

  },
  countDiv:{
    display:'flex',
    alignItems:'center',
    padding:'20px 0'
  },
  countSpan:{
    width:'100px',
  },
  countBtnDiv:{
    display:'flex',
    justifyContent:'space-evenly',
    alignItems:'center',
    border:'1px solid #AAA',
    borderRadius:'3px',
    width:'90px',
    height:'35px',
  },
  countBtn:{
    background:'none',
    fontSize:'20px',
    color:'#555',
  },
  countH1:{
    padding:'0 10px'
  },
  cartIcon:{
    fontSize:'22px',
  },
  addBtnDiv:{
    display:'flex',
    justifyContent:'center'
  },

  itemDetailPageDiv:{
    paddingTop:'50px',
  },
  itemDetailPage:{
    borderTop:'1px solid #555',
    borderBottom:'1px solid #CCC',
    paddingBottom:'50px',
  },
  titleDiv:{
    display:'flex',
    justifyContent:'space-evenly',
    borderBottom:'1px solid #CCC',
  },
  titleThHover:{
    borderBottom:'2px solid #007235',
    padding:'15px 0',
    color:'#232323',
    fontWeight:'500',
    position:'relative',
  },
  title:{
    padding:'15px 0',
    color:'#232323',
    fontWeight:'500',
  },
  detailContent:{
  },
  detailContentSpan:{
    paddingTop:'50px',
    
  },


  bordListBox:{
    padding:'10px 0 30px 0'
  },
  Titles: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '2px solid #007235',
    borderBottom: '2px solid #CCCCCC',
    paddingTop: 12,
    paddingBottom: 12,

    [theme.breakpoints.down(1025)]: {
      borderBottom:'none',
      paddingTop: 0,
    },
  },
  TitlesItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 300,

    [theme.breakpoints.down(1025)]: {
      display:'none',
    },

  },
  ItemBox:{
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: '2px solid #ccc',
    paddingTop: 12,
    paddingBottom: 12,
    color:'#555555',

    [theme.breakpoints.down(1025)]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  borderItemUp:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize:'14px',

    [theme.breakpoints.down(1025)]: {
      display:'none'
    },
  },
  borderItemDiv:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,

    [theme.breakpoints.down(1025)]: {
      justifyContent:'flex-start',
      marginLeft: 5,
    },

  },
  borderItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize:'14px',
    '&:first-child':{ 
      flex: 0.2
    },
    '&:last-child':{ 
      flex: 1
    },

    [theme.breakpoints.down(1025)]: {
      '&:first-child':{ 
        flex: 0.5
      },
      '&:last-child':{ 
        flex: 1,
      },
    },
  },
  subjectBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
    justifyContent:'center',

    [theme.breakpoints.down(1025)]: {
      justifyContent:'flex-start',
    },
  },
  ItemSubject: {
    marginLeft: 5,
    marginRight: 5,
    cursor: 'pointer',
    fontSize:'14px',

    [theme.breakpoints.down(1025)]: {
      
    }
  },
  timeIcon:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      flex:'0.2',
      display:'flex',
      alignItems: 'center',
    }
  },
  eyeIcon:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      flex:'0.2',
      display:'flex',
      alignItems: 'center',
    }
  },


  modalBox: {
    width: 500,
    height: 330,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  },
  modalBox2: {
    width: 500,
    height: 500,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalSpan:{
    display:'block',
    padding:'10px 0 10px 15px',
    fontWeight:'600',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  modalSpan2:{
    display:'block',
    fontWeight:'600',
    paddingBottom:'10px',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  modalSecretDiv:{
    display:'flex',
    alignItems:'center'
  },
  modalSecretSpan:{
    padding:'10px 0 10px 15px',
    fontWeight:'600',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  modalBtn:{
    display:'flex',
    justifyContent:'center',
    padding:'10px 0'
  },
  textFieldDiv:{
    display:'flex',
    justifyContent:'center'
  },
  ItemBoxBtn:{
    display:'flex',
    justifyContent:'flex-end'
  },
  innerClass: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
    listStyle: 'none',
    padding: 0,
  },
  itemClass: {
    width: '36px',
    height: '30px',
    border: '1px solid #CCC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1rem',
  },
  itemClassFirst: {
  },
  itemClassLast: {
  },
  linkClass: {
    textDecoration: 'none',
    fontSize: '0.8rem',
  },
  activeClass: {
    backgroundColor: '#007235'
  },
  activeLinkClass: {
    color: 'white',
  },

  contentModalDiv:{
    padding:'10px',
  },
  contentDiv:{
    padding:'10px 0',
    borderBottom:'2px solid #CCC',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
  },
}));

const ShopItemAll = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const login = useSelector(state => state.user.login);
  const mbId = useSelector(state => state.user.userInfo['mb_id']);
  const mbName = useSelector(state => state.user.userInfo['mb_name']);
  const mbLevel = useSelector(state => state.user.userInfo['mb_level']);
  const sendCost = useSelector(state => state.config.shopDefaultConfig.de_send_cost_list);
  const location = useLocation();

  const [dialog, setDialog] = useState('');
  
  const [data, setData] = useState('');
  const [qty, setQty] = useState(1);
  const [qaList, setQaList] = useState([]);
  const [page, setPage] = useState(1);
  const [qaItemList, setQaItemList] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [wrModalOpen, setWrModalOpen] = useState(false)
  const [qaCont, setQaCont] = useState()
  const [qaSub, setQaSub] = useState('')
  const [qaQuest, setQaQuest] = useState('')
  const [qaSecret, setQaSecret] = useState(0)

  const [imgListBox, setImgListBox] = useState([])
  const [mainImgBox, setMainImgBox] = useState('')

  useEffect(() => {
    window.scrollTo(0, 0);

  }, [])


  const increase = () => {
      if (qty + 1 >= data['it_stock_qty']) return setQty(data['it_stock_qty']);
      setQty(qty + 1);
  }

  const decrease = () => {
    if( qty >= 2) {
      setQty(qty - 1);
    }
  }

  const getItem = async() => {
    try {
        const res = await axios.get(`/api/shop/shopItemAll/${location.state.itId}/`)

        if(res.data.success === false) {
            setDialog('불러오기 실패')
            return
        }

        let imgList = []
        
        if(res.data.result['it_img1']) {
          imgList.push(res.data.result['it_img1'])
        }
        setMainImgBox(res.data.result['it_img1'])

        if(res.data.result['it_img2']) {
          imgList.push(res.data.result['it_img2'])
        }
        if(res.data.result['it_img3']) {
          imgList.push(res.data.result['it_img3'])
        }
        if(res.data.result['it_img4']) {
          imgList.push(res.data.result['it_img4'])
        }
        if(res.data.result['it_img5']) {
          imgList.push(res.data.result['it_img5'])
        }
        if(res.data.result['it_img6']) {
          imgList.push(res.data.result['it_img6'])
        }
        if(res.data.result['it_img7']) {
          imgList.push(res.data.result['it_img7'])
        }
        if(res.data.result['it_img8']) {
          imgList.push(res.data.result['it_img8'])
        }
        if(res.data.result['it_img9']) {
          imgList.push(res.data.result['it_img9'])
        }
        if(res.data.result['it_img10']) {
          imgList.push(res.data.result['it_img10'])
        }

        setImgListBox(imgList)
        setQaList(res.data.qaList)

        setData(res.data.result)

      } catch (e) {
        console.log(e)
      }
  }

  useEffect(() => {
    if(location.state.itId) {
      getItem()
    }
  }, [location.state.itId])

  const handlePageChange = (page) => {
    setPage(page);
  };

  useEffect(() => {
    setQaItemList(qaList.slice((5 * page ) - 5, (5 * page )))
  }, [page, qaList])



  const onQaSubmit = async() => {
    if(qaSub === '') return setDialog('제목을 입력해 주세요.')
    if(qaQuest === '') return setDialog('내용을 입력해 주세요.')

    let ip = ''

    // try {
    //   const response = await axios.get('https://api.ipify.org?format=json');
    //   ip = response.data.ip;
    // } catch (error) {
    //   console.error(error);
    //   return
    // }

    try {
        const res = await axios.post(
          '/api/shop/addQa/', 
          {
            it_id: location.state.itId,
            mb_id: mbId,
            iq_name: mbName,
            iq_secret: qaSecret,
            iq_subject: qaSub,
            iq_question: qaQuest,
            iq_ip: ip,
          }
        )

        if(res.data.success === false) {
            setDialog('실패하였습니다.')
            return
        }


        setQaSub('')
        setQaQuest('')
        setQaSecret(0)
        setWrModalOpen(false)
        setDialog('질문이 등록되었습니다.')
        getItem()


      } catch (e) {
        console.log(e)
      }
  }


  const onDelQa = async(id) => {

    try {
        const res = await axios.post(
          '/api/shop/delQa/', 
          {
            iq_id: id
          }
        )

        if(res.data.success === false) {
            setDialog('실패하였습니다.')
            getItem()
            setModalOpen(false)
            return
        }


        getItem()
        setModalOpen(false)
        setDialog('질문이 삭제되었습니다.')

      } catch (e) {
        console.log(e)
      }
  }

  const addCart = async() => {
    if (!login) return setDialog('로그인후 이용 해주세요.')
    if (data['it_soldout'] === 1) return setDialog('품절된 상품 입니다.')
    if (data['it_stock_qty'] === 0) return setDialog('품절된 상품 입니다.')

    let ip = ''
    let cartItems =[]

    try {
      const res = await axios.post('/api/shop/getCart/', {mb_id: mbId})
      if(res.data.success === false) {
        setDialog('실패하였습니다.')
        return
      }
      
      res.data.result.forEach(itm => {
        cartItems.push(itm.it_id)
      })

  
    } catch (e) {
      console.log(e)
    }

    if (cartItems.includes(data['it_id'])) return setDialog('이미 카트에 존재하는 상품입니다.')


    // try {
    //   const response = await axios.get('https://api.ipify.org?format=json');
    //   ip = response.data.ip;
    // } catch (error) {
    //   console.error(error);
    //   return
    // }


    try {
        const res = await axios.post(
          '/api/shop/addCart/', 
          {
            mb_id: mbId,
            it_id: location.state.itId,
            ct_qty: qty,
            ct_ip: ip,
          }
        )

        if(res.data.success === false) {
            setDialog('실패하였습니다.')
            return
        }

        setDialog('카트에 추가 되었습니다.')

      } catch (e) {
        console.log(e)
      }
  }



  return (
    <div className={classes.ShopItemBlock}>
      
      <div className={classes.row}>
        <div className={classes.rightLeftFlexDiv}>
          <div className={classes.LeftDiv}>
            <div className={classes.imgDiv}>
                <div 
                  className={classes.smallImgDiv} 
                >
                    {imgListBox.length > 0 && imgListBox.map((item) => {
                      return(
                        <div 
                          key={item}
                          style={{ backgroundImage:`url(${mainPath}/media/data/item/${item})`}}
                          className={classes.smallImg}
                          onClick={() => setMainImgBox(item)}
                        ></div>
                      )
                    })}
                </div>
                <div 
                  className={classes.smallImgDivM} 
                >
                    {imgListBox.length > 0 && imgListBox.map((item) => {
                      return(
                        <div 
                          key={item}
                          style={{ backgroundImage:`url(${mainPath}/media/data/item/${item})`}}
                          className={classes.smallImgM}
                          onClick={() => setMainImgBox(item)}
                        ></div>
                      )
                    })}
                </div>
              <div className={classes.mainImgDiv}>
                {mainImgBox && 
                  <img 
                    src={`${mainPath}/media/data/item/${mainImgBox}`}  
                    alt='' 
                    className={classes.mainimg}
                  />
                }
              </div>
            </div>
          </div>
          <div className={classes.rightDiv}>
            <div className={classes.h1Div}>
              <h1 className={classes.rightDivH1}>
                {data['it_name']}
              </h1>
            </div>
            <div className={classes.itemDetailDiv}>
              <div className={classes.itemDetailSpanFirstDiv}>
                <span className={classes.itemDetailSpan}>판매가</span>
                <span>
                  {!login ? '회원공개' : data['it_price'] && data['it_price'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') } 원
                </span>
              </div>
              <div className={classes.itemDetailSpanDiv}>
                <span className={classes.itemDetailSpan}>적립금</span>
                <span>{!login ? '회원공개' : data['it_point'] && data['it_point'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
              </div>
              <div className={classes.itemDetailSpanDiv}>
                <span className={classes.itemDetailSpan}>판매시기</span>
              </div>
              <div className={classes.itemDetailSpanDiv}>
                <span className={classes.itemDetailSpan}>배송비</span>
                <span>{!login ? '회원공개' : sendCost && sendCost.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
              </div>
              <div className={classes.itemDetailSpanDiv}>
                <span className={classes.itemDetailSpan}>원산지</span>
              </div>
              <div className={classes.itemDetailSpanLastDiv}>
                <span className={classes.itemDetailSpan}>생산자</span>
              </div>
            </div>
            <div className={classes.cartDiv}>
              <div className={classes.countDiv}>
                <span className={classes.countSpan}>구매수량</span>
                {
                  data['it_stock_qty'] === 0 ? (
                    <h1 className={classes.countH1} style={{ color: '#B22202'}}>
                      품절
                    </h1>    
                  ): (
                    <div className={classes.countBtnDiv}>
                      <button 
                        onClick={decrease}
                        className={classes.countBtn}
                      >
                        -
                      </button>  
                      <h1 className={classes.countH1}>
                        {qty}
                      </h1>                  
                      <button 
                        onClick={increase}
                        className={classes.countBtn}
                      >
                        +
                      </button>
                    </div>
                  )
                }   

              </div>


              <div className={classes.addBtnDiv}>
                <Button
                  onClick={addCart} 
                  style={{
                    border:'1px solid #007235', 
                    borderRadius:'3px', 
                    background:'#fff', 
                    width:'100%', 
                    height:'40px',
                  }}
                >
                  <RiShoppingCartLine className={classes.cartIcon}/>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.itemDetailPageDiv}>
          <div className={classes.itemDetailPage}>
            <div className={classes.titleDiv}>
              <div className={classes.titleThHover}>상품상세</div>
              <div className={classes.title}>상품문의</div>
            </div>
            <div className={classes.detailContent}>
                  <div className={classes.detailContentSpan}>
                    제품 상세페이지를 등록해주세요
                  </div>
                  <div>
                    <span>
                      {<div dangerouslySetInnerHTML={{__html: data['it_explan']}}/>}
                    </span>
                  </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.row}>
        <div className={classes.productInquiryPageDiv}>
          <div className={classes.itemDetailPage}>
            <div className={classes.titleDiv}>
              <div className={classes.title}>상품상세</div>
              <div className={classes.titleThHover}>상품문의</div>
            </div>
            <div className={classes.detailContent3}>
                  <div className={classes.detailContentSpan}>
                    문의사항을 남겨주세요.
                  </div>

                  <div className={classes.bordListBox}>
                    <div className={classes.Titles}>
                        <h1 className={classes.TitlesItem} style={{flex: 1.19}}>제목</h1>
                        <h1 className={classes.TitlesItem} style={{flex: 0.2}}>작성자</h1>
                        <h1 className={classes.TitlesItem} style={{flex: 1}}>등록일</h1>
                    </div>
                    {qaItemList.length > 0 && qaItemList.map((item) => (
                      <div 
                        key={item['iq_id']}
                        onClick={() => {
                          if(item['iq_secret'] === 1 && mbId !== item['mb_id'] && mbLevel !== 10) return setDialog('권한이 없습니다.')

                          setQaCont({
                            iqId: item['iq_id'],
                            mbId: item['mb_id'], 
                            iqName: item['iq_name'], 
                            iqSubject: item['iq_subject'], 
                            qQuestion: item['iq_question'], 
                            iqAnswer: item['iq_answer'], 
                            iqTime: item['iq_time']
                          })
                          setModalOpen(true)
                        }}
                      >
                        <div className={classes.ItemBox}>
                          <div className={classes.subjectBox} style={{flex: 1}}>
                            <p className={classes.ItemSubject}>
                              {item['iq_secret'] === 1 && <MdLockOutline size="15" />} {item['iq_subject']}
                            </p>
                          </div>
                          <div className={classes.borderItemDiv}>
                            <h1 className={classes.borderItem}>
                              {item['iq_name']}
                            </h1>
                            <h1 className={classes.borderItem}>
                              <BiTimeFive className={classes.timeIcon}/>
                              {item['iq_time'].substr(0, 10)}
                            </h1>
                          </div>
                        </div>
                      </div>
                      ))}

                      <div className={classes.ItemBoxBtn}>
                        {login && (
                          <Button
                            onClick={() => setWrModalOpen(true)} 
                            style={{ 
                              margin:'30px 0 10px 0', 
                              fontWeight:'600', 
                              textAlign:'left', 
                              background:'#007235', 
                              color:'#fff', 
                              borderRadius:'0', 
                              fontFamily:[
                                'Noto Sans KR'
                              ],
                            }}
                          >
                            문의하기
                          </Button>
                        )}
                      </div>
  
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={5}
                        totalItemsCount={qaList.length}
                        pageRangeDisplayed={5}
                        prevPageText={"‹"}
                        nextPageText={"›"}
                        onChange={handlePageChange}
                        className={classes.navi}
                        innerClass={classes.innerClass}    //안에?
                        itemClass={classes.itemClass}      //아이템들?
                        itemClassFirst={classes.itemClassFirst}    //first?
                        itemClassLast={classes.itemClassLast}     // last
                        linkClass={classes.linkClass}        // 아이템 링크
                        activeClass={classes.activeClass}        // 현재페이지
                        activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
                    />
                    
                  </div>
            </div>
          </div>
        </div>
      </div>
      




      <Dialog
          open={dialog === '' ? false : true}
          onClose={() => setDialog('')}
      >
      <DialogTitle id="alert-dialog-title">
          {dialog}
      </DialogTitle>
      <DialogActions>
          <Button onClick={() => setDialog('')} autoFocus>
            확인
          </Button>
      </DialogActions>
      </Dialog>

      <Modal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={classes.modal}
      >
        <Box
          className={classes.modalBox2}
        >
              <div className={classes.contentModalDiv}>
                <div className={classes.contentDiv}>
                  <span className={classes.modalSpan2}>글쓴이</span>  
                  <p>{qaCont && qaCont.iqName}</p>
                </div>
                <div className={classes.contentDiv}>
                  <span className={classes.modalSpan2}>시간</span>  
                  <p>{qaCont && qaCont.iqTime.substr(0, 10)}</p>
                </div>
                <div className={classes.contentDiv}>
                  <span className={classes.modalSpan2}>제목</span>  
                  <p>{qaCont && qaCont.iqSubject}</p>
                </div>
                <div className={classes.contentDiv}>
                  <span className={classes.modalSpan2}>내용</span> 
                  <p>{qaCont && qaCont.qQuestion}</p>
                </div>
                <div className={classes.contentDiv}>
                  <span className={classes.modalSpan2}>답변</span>  
                  <p>{qaCont && <div dangerouslySetInnerHTML={{__html: qaCont.iqAnswer}}/>}</p>
                </div>
              </div>
          <div className={classes.btnDiv}>
            <Button
              onClick={() => setModalOpen(false)} 
              style={{ 
                border:'1px solid #007235',
                fontFamily:[
                  'Noto Sans KR'
                ],
              }}
            >
              확인
            </Button>
            {qaCont && (qaCont.mbId === mbId || mbLevel === 10) && (
                  <Button
                    onClick={() => onDelQa(qaCont.iqId)} 
                    style={{ 
                      background:'#007235', 
                      color:'#fff', 
                      marginLeft:'10px', 
                      fontFamily:[
                        'Noto Sans KR'
                      ],
                    }}
                  >
                    삭제
                  </Button>
            )}

          </div>

        </Box>
      </Modal>
      <Modal
        open={wrModalOpen}
        onClose={() => {
          setQaSub('')
          setQaQuest('')
          setQaSecret(0)
          setWrModalOpen(false)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={classes.modal}
      >
        <Box
          className={classes.modalBox}
        >
              <div>
                <span className={classes.modalSpan}>제목</span> 
                <div className={classes.textFieldDiv}>
                  <TextField
                    hiddenLabel
                    id="filled-hidden-label-small"
                    value={qaSub}
                    variant="outlined"
                    size="small"
                    style={{ 
                      width:'95%', 
                      fontFamily:[
                        'Noto Sans KR'
                      ],
                  }}
                    fullWidth
                    onChange={(e) => {setQaSub(e.target.value)}}
                  />
                </div>
              </div>
              <div>
                <span className={classes.modalSpan}>내용</span>
                <div className={classes.textFieldDiv}>
                  <textarea 
                    value={qaQuest} 
                    onChange={(e) => setQaQuest(e.target.value)} 
                    style={{ 
                      width:'95%', 
                      height:'100px',
                      fontFamily:[
                        'Noto Sans KR'
                      ],
                    }}
                  />
                </div>
              </div>
              <div className={classes.modalSecretDiv}>
                <span className={classes.modalSecretSpan}>비밀글</span>
                <Checkbox
                    checked={qaSecret === 0 ? false : true}
                    onChange={() => qaSecret === 0 ? setQaSecret(1) : setQaSecret(0)}
                  />
              </div>

          <div className={classes.modalBtn}>
            <Button
              onClick={() => {
                setQaSub('')
                setQaQuest('')
                setQaSecret(0)
                setWrModalOpen(false)
              }}
              style={{                
                border:'1px solid #007235',
                fontFamily:[
                  'Noto Sans KR'
                ],
              }}
            >
              취소
            </Button>
            <Button
              onClick={() => onQaSubmit()} 
              style={{ 
                background:'#007235', 
                color:'#fff', 
                marginLeft:'10px',
                fontFamily:[
                  'Noto Sans KR'
                ], 
              }}
            >
              확인
            </Button>
          </div>

        </Box>
      </Modal>
    </div>
  )
}

export default ShopItemAll
